// @flow
import React, { Component } from 'react';
import type { Cohort } from 'types/entities';
import classnames from 'classnames';

import _ from 'lodash';

import './BookingStatsPanel.scss';

import {
  entityURLForCohort,
} from '../../../utils/cohort-utils';

import {
  bookingStateString,
} from '../../../utils/booking-utils';

type Props = {
  cohort: Cohort,
}

/* eslint-disable react/prefer-stateless-function */
export default class BookingStatsPanel extends Component {

  constructor(props: Props) {
    super(props);
    this.state = {
      show: true,
    };
  }

  props: Props;

  generateStats = () => {
    const {
      cohort,
    } = this.props;
    const driverBookings = {};
    _.each(cohort.drivers, (driver) => {
      _.each(driver.bookings, (booking) => {
        driverBookings[booking.bookingID] = {
          ...booking,
          driverID: driver.cohortDriverID,
        };
      });
    });

    const passengerBookings = [];
    _.each(cohort.passengers, (passenger) => {
      _.each(passenger.bookings, (booking) => {
        passengerBookings.push({
          ...booking,
          passengerID: passenger.cohortPassengerID,
        });
      });
    });

    if (_.isEmpty(passengerBookings)) {
      return null;
    }

    return _.map(passengerBookings, (booking, idx) => {
      const driverBooking = driverBookings[booking.bookingID];
      return (
        <tr key={booking.bookingID}>
          <td>{idx + 1}</td>
          <td>
            <a
              href={`${entityURLForCohort()}/passengers/${booking.passengerID}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {booking.passengerID}
            </a>
          </td>
          <td>{driverBooking ? (
            <a
              href={`${entityURLForCohort()}/drivers/${driverBooking.driverID}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {driverBooking.driverID}
            </a>
          ) : '-'}</td>
          <td>
            <a
              href={`${entityURLForCohort()}/bookings/${booking.bookingID}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {booking.bookingID}
            </a>
          </td>
          <td>{bookingStateString(booking.state)}</td>
        </tr>
      );
    });
  }

  render() {
    const stats = this.generateStats();
    if (!stats) {
      return null;
    }

    return (
      <div className="stats-panel">
        <div className="panel-content">
          <div className="panel-header">
            <div className="control-btn">
              <a onClick={() => {
                const cur = this.state.show;
                this.setState({
                  show: !cur,
                });
              }}
              ><i className={classnames('fa', {
                'fa-expand': !this.state.show,
                'fa-minus-square': this.state.show,
              })}
              /></a>
            </div>
          </div>
          <div className="panel-body">
            <table className={classnames('table is-striped is-bordered')}>
              <thead>
                <tr className={classnames('', {
                  'is-hidden': !this.state.show,
                })}
                >
                  <th>No.</th>
                  <th><abbr title="Passenger">Pax</abbr></th>
                  <th><abbr title="Driver">Dax</abbr></th>
                  <th>Booking No.</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody className={classnames('', {
                'is-hidden': !this.state.show,
              })}
              >
                {stats}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/views/autosim/simulation/BookingStatsPanel.jsx
 **/